import { fieldCls } from "./AuthShell.js";

export function ImportPastePanel({
  value,
  onChange,
  preview,
  duplicates,
  id,
  autoFocus = false,
  remaining,
}: {
  value: string;
  onChange: (raw: string) => void;
  preview: string[];
  /** Repeated lines the parser removed from the paste. */
  duplicates?: number;
  id?: string;
  autoFocus?: boolean;
  /** Slots left before the item cap. When the preview is longer, warn how many are skipped. */
  remaining?: number;
}) {
  return (
    <>
      <textarea
        id={id}
        className={`${fieldCls} min-h-[10rem] font-mono text-sm`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={"- Towel\n1. Goggles\nSwim cap, blue\n• Flip-flops"}
        autoFocus={autoFocus}
      />
      <div className="mt-4">
        <p className="text-sm font-medium text-ink">
          Preview ({preview.length} item{preview.length === 1 ? "" : "s"})
        </p>
        {duplicates ? (
          <p className="mt-2 text-sm text-muted">
            {duplicates} repeated line{duplicates === 1 ? "" : "s"} removed.
          </p>
        ) : null}
        {remaining !== undefined && preview.length > remaining ? (
          <p className="mt-2 text-sm text-danger">
            Only {remaining} more item{remaining === 1 ? "" : "s"} fit.{" "}
            {preview.length - remaining} will be skipped.
          </p>
        ) : null}
        {preview.length === 0 ? (
          <p className="mt-2 text-sm text-muted">Nothing to import yet.</p>
        ) : (
          <ul className="mt-2 max-h-40 list-inside list-disc overflow-y-auto text-sm text-ink">
            {preview.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}
